import * as companyInfo from './companyInfo';

import {combineReducers} from "redux";
import {all, fork} from "redux-saga/effects";

export interface IState  {
    companyInfo: companyInfo.IState
}

export const ActionCreators = {
    companyInfo: companyInfo.ActionCreators
}

export const Reducers = combineReducers<IState>({
    companyInfo: companyInfo.Reducers
});

export function* sagas() {
    yield all([
        fork(companyInfo.sagas)
    ]);
}

